import { useState } from "react";
import { ChevronRight, Check, ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { resources, CHECKOUT_URL } from "../../data/academyData";

export const ResourcesGrid = () => {
  const [selected, setSelected] = useState(null);
  const glowColors = ["rgba(229,9,20,0.35)"];

  return (
    <section id="resources" data-testid="resources-grid-section" className="relative py-20 md:py-32 bg-[#08080A] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold mb-4">What You Get</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white max-w-2xl leading-tight">
            21 Secrets on Sex, Love, and Intimacy. Yours Instantly.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resources.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <button
                onClick={() => setSelected(r)}
                data-testid={`resource-card-chapter-${r.id}`}
                className="group relative w-full text-left rounded-2xl bg-white/[0.03] border border-white/10 p-6 sm:p-8 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:border-rose-500/40 hover:shadow-[0_12px_40px_rgba(229,9,20,0.2)]"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -top-10 -right-10 h-32 w-32 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse"
                  style={{ background: glowColors[i % glowColors.length] }}
                />
                <div className="relative flex items-start justify-between">
                  <span className="font-mono text-3xl font-bold text-white/15">{String(r.id).padStart(2, "0")}</span>
                  <ChevronRight size={18} className="text-zinc-500 transition-transform group-hover:translate-x-0.5" />
                </div>
                <h3 className="relative mt-4 font-heading text-lg sm:text-xl font-medium text-white">{r.title}</h3>
                <p className="relative mt-1.5 text-sm text-zinc-400 leading-snug">{r.summary}</p>
                <p className="relative mt-3 text-xs text-rose-400 font-mono uppercase tracking-widest">View preview →</p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent
          data-testid="resource-preview-modal"
          className="bg-[#0d0d10] border border-rose-500/30 text-white rounded-3xl max-w-lg p-8 max-h-[85vh] overflow-y-auto"
        >
          {selected && (
            <>
              <DialogTitle className="sr-only">{selected.title}</DialogTitle>
              <span className="font-mono text-5xl font-bold text-rose-500/25">{String(selected.id).padStart(2, "0")}</span>
              <h3 className="mt-3 font-heading text-2xl font-bold leading-tight">{selected.title}</h3>
              <p className="mt-3 text-zinc-400 leading-relaxed">{selected.description}</p>
              <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-amber-400 font-semibold">What You'll Learn</p>
              <ul className="mt-3 space-y-2.5" data-testid="resource-modal-toc-list">
                {selected.toc.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-zinc-200">
                    <Check size={15} className="text-emerald-400 mt-0.5 shrink-0" /> {item}
                  </li>
                ))}
              </ul>
              <a
                href={CHECKOUT_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="resource-modal-cta-button"
                className="mt-7 w-full inline-flex items-center justify-center gap-2 rounded-full bg-rose-600 hover:bg-rose-500 text-white font-semibold text-base px-6 py-3.5 transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(229,9,20,0.4)]"
              >
                Unlock This & 20 More Secrets <ArrowRight size={18} />
              </a>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
